
export const SCOPE_3_INCLUDES = [
    {label: "Employee working from home energy", value: "work-from-home"},
    {label: "Distribution of advertising (digital or linear)", value: "advertising"},
    {label: "Energy related to hosting or publishing media", value: "media"},
    {label: "All purchased goods and services", value: "purchased-goods"},
    {label: "Capital goods", value: "capital-goods"},
    {label: "Fuel- and energy-related activities (not included in scope 1 and 2)", value: "fuel-energy"},
    {label: "Upstream transportation and distribution", value: "upstream-transportation"},
    {label: "Waste generated in operations", value: "waste"},
    {label: "Business travel", value: "business-travel"},
    {label: "Employee commuting", value: "employee-commuting"},
    {label: "Upstream leased assets", value: "upstream-leased-assets"},
    {label: "Downstream transportation and distribution", value: "downstream-transportation"},
    {label: "Processing of sold products", value: "processing"},
    {label: "Use of sold products", value: "use-of-sold-products"},
    {label: "End-of-life treatment of sold products", value: "end-of-life-treatment"},
    {label: "Downstream leased assets", value: "downstream-leased-assets"},
    {label: "Franchises", value: "franchises"},
    {label: "Investments", value: "investments"},
]

